import { useEffect, useState } from "react";
import { Loader2, Square } from "lucide-react";
import { toast } from "sonner";
import { Progress } from "@/components/ui/progress";
import { getJobProgress, cancelJob } from "@/lib/agent";

const fmt = (s) => {
  if (!isFinite(s) || s < 0) return "—";
  const m = Math.floor(s / 60), sec = Math.round(s % 60);
  return m ? `${m} min ${sec}s` : `${sec}s`;
};

export function JobProgress({ watch }) {
  const [j, setJ] = useState(null);

  useEffect(() => {
    let alive = true;
    const tick = () => getJobProgress().then((d) => alive && setJ(d)).catch(() => alive && setJ(null));
    tick();
    const id = setInterval(tick, 2000);
    return () => { alive = false; clearInterval(id); };
  }, [watch]);

  if (!j?.active) return null;
  const pct = j.total ? (j.step / j.total) * 100 : null;
  const eta = j.total && j.step ? (j.elapsed / j.step) * (j.total - j.step) : NaN;

  const cancel = async () => {
    if (!window.confirm("¿Cancelar la generación en curso?")) return;
    const d = await cancelJob().catch(() => null);
    d?.ok ? toast.success(d.message) : toast.error("No se pudo cancelar");
  };

  return (
    <div className="mt-4 rounded-sm border border-emerald-500/30 bg-emerald-500/5 p-4" data-testid="job-progress">
      <div className="flex items-center justify-between gap-3">
        <div className="flex items-center gap-2 text-sm text-emerald-300">
          <Loader2 className="h-4 w-4 animate-spin" />
          <span className="font-heading font-semibold">Procesando en tu Mac · {j.tool}</span>
        </div>
        <button onClick={cancel} data-testid="job-cancel" className="inline-flex items-center gap-1.5 rounded-sm border border-red-500/50 bg-red-500/10 px-3 py-1 text-xs text-red-300 hover:bg-red-500/20">
          <Square className="h-3 w-3" />Cancelar
        </button>
      </div>
      <Progress value={pct ?? 0} className="mt-3 h-2 bg-[#1a1a1a] [&>div]:bg-emerald-400" />
      <div className="mt-2 flex flex-wrap gap-x-5 font-mono text-[11px] text-[#d4d4d4]" data-testid="job-progress-stats">
        <span>{j.total ? `Paso ${j.step} de ${j.total} · ${pct.toFixed(0)}%` : "Cargando modelo en memoria…"}</span>
        <span>Transcurrido: {fmt(j.elapsed)}</span>
        <span>Quedan: {fmt(eta)}</span>
      </div>
      {j.last_line && <p className="mt-1 truncate font-mono text-[10px] text-[#737373]" title={j.last_line}>{j.last_line}</p>}
    </div>
  );
}
